import Shell from "@/pages/Shell";
import { Seo } from "@/components/Seo";
import { Events } from "@/components/Events";
import { Appointment } from "@/components/Appointment";

export default function EventsPage() {
  return (
    <Shell>
      {(scrollToId) => (
        <>
          <Seo
            title="Events, Revivals & Book Signings — Charles McKuhn"
            description="Upcoming revivals, book signings, and keynote engagements with Apostle Charles McKuhn. Find where to encounter the Word, deliverance, and the move of the Holy Ghost next."
            path="/events"
          />
          <h1 className="sr-only">Events, Revivals & Book Signings — Charles McKuhn</h1>
          <Events scrollToId={scrollToId} />
          <Appointment />
        </>
      )}
    </Shell>
  );
}
